<template>
  <div class="form__opinion-range">
    <inline-field-actions :schema="schema"></inline-field-actions>
    <div class="list-view list-view--compact">
      <div class="list-view__header">
        <div></div>
        <div class="text-center">1{{ startLabel }}</div>
        <div v-for="index in 5">{{ index + 1 }}</div>
        <div class="text-center">7{{ endLabel }}</div>
      </div>
      <div class="list-view__row flex" v-for="item in items">
        <div class="text-center">{{ getItemName(item) }}</div>
        <div class="input input--radio input--radio-inline" :class="{'is-checked': isItemChecked(item, index)}" v-for="index in 7">
          <label>
            <input type="radio" class="input__default input__default--radio" :disabled="disabled" @click="onSelection(item, index)" :value="getItemValue(item, index)" :checked="isItemChecked(item, index)">
            <div class="input__styled input__styled--radio"></div>
            <span class="list-view__small-value">{{ index }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { abstractField } from 'vue-form-generator';
  import { mapMutations } from 'vuex';
  import clone from 'lodash.clone';

  export default {
    /* eslint-disable no-throw-literal */
    /* eslint-disable max-len */

    mixins: [abstractField],

    computed: {
      items() {
        const values = this.schema.values;
        if (typeof (values) === 'function') {
          return values.apply(this, [this.model, this.schema]);
        } return values;
      },

      selectedCount() {
        if (this.value) { return this.value.length; }

        return 0;
      },

      startLabel() {
        return this.schema.startLabel ? ` - ${this.schema.startLabel}` : '';
      },

      endLabel() {
        return this.schema.endLabel ? ` - ${this.schema.endLabel}` : '';
      },
    },

    methods: {
      ...mapMutations('admin', [
        'setFormChanged',
      ]),

      getItemValue(item, index) {
        if (item) {
          if (
            typeof this.schema.radiosOptions !== 'undefined'
            && typeof this.schema.radiosOptions.value !== 'undefined'
          ) {
            return item[this.schema.radiosOptions.value];
          }
          if (typeof item.value !== 'undefined') {
            return `${item.originalValue}: ${index}`;
          }
          throw '`value` is not defined. If you want to use another key name, add a `value` property under `radiosOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/radios.html#radios-field-with-object-values';
        } else {
          return item;
        }
      },

      getItemName(item) {
        if (item) {
          if (typeof this.schema.radiosOptions !== 'undefined' && typeof this.schema.radiosOptions.name !== 'undefined') {
            return item[this.schema.radiosOptions.name];
          }
          if (typeof item.name !== 'undefined') {
            return item.name;
          }
          throw '`name` is not defined. If you want to use another key name, add a `name` property under `radiosOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/radios.html#radios-field-with-object-values';
        } else {
          return item;
        }
      },

      onSelection(item, index) {
        if (!this.value || !Array.isArray(this.value)) {
          this.value = [];
        }
        // Note: If you modify this.value array, it won't trigger the `set` in computed field
        const arr = clone(this.value);
        const valueIndex = this.value.findIndex(val => val.startsWith(`${item.originalValue}: `));
        if (valueIndex >= 0) {
          arr.splice(valueIndex, 1);
        }
        arr.push(this.getItemValue(item, index));
        this.value = arr;
        this.setFormChanged(true);
        return this.value;
      },

      isItemChecked(item, index) {
        const currentValue = this.getItemValue(item, index);
        if (this.value) {
          return (this.value.indexOf(currentValue) >= 0);
        }
        return false;
      },
    },
  };
</script>
